import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IPost } from '../../core/models/post';
import { IWall } from '../../core/models/wall';
import { Button, Card, CardActionArea, CardActions, CardContent, CardMedia, Collapse, IconButton, Tooltip, Typography, withStyles } from '@material-ui/core';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import { User } from '../../core/models/user';
import { ADD_COMMENT, REMOVE_POST, REQUEST_COMMENTS, UPDATE_FEATUREDPOST, UPDATE_LIKE } from '../../core/handlers.actions';
import clsx from 'clsx';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Comment from '../comment';
import { IComment } from '../../core/models/comment';
import { SpeedDial, SpeedDialAction } from '@material-ui/lab';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import PostAddEdit from './add.edit';
import CreateIcon from '@material-ui/icons/Create';
import ImageModal from '../modal/postimage';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';

const styles = (theme: any) => ({
    root: { maxWidth: 345, borderRadius: 0 },
    enlightedPost: {maxWidth: 345, borderRadius: 0, boxShadow: '5px -6px 12px -2px #1DA1F2, -8px 4px 20px #4267B2', transition: 'all 1s'},
    likeButton: {
        padding: '5px 7px',
        margin: theme.spacing(0),
        '& .MuiSvgIcon-root': {
            width: '.8em',
            height: '.8em',
        }
    },
    shareButton: {
        padding: '5px 7px',
        margin: theme.spacing(0),
        '& .MuiSvgIcon-root': {
            width: '.8em',
            height: '.8em',
        }
    },
    bodyText: {
        root: { padding: '5px 16px' }
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    postComment: {
        '& .MuiSvgIcon-root': {
            width: '.8em',
            height: '.8em'
        }
    },
    speedDial: {
        position: 'absolute' as any,
        display: 'none',
        '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
            right: theme.spacing(0),
            top: theme.spacing(-3),
        }
    },
    nameHolder: {
        paddingTop: '10px!important'
    },
    name: {
        fontSize: '16px!important',            
        color: '#383838',
        lineHeight: 1,
        marginBottom: '6px!important'
    },
    eventname: {
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(1),
        fontSize: '16px!important',            
        color: '#383838',
        textTransform: 'capitalize' as any
    },
    editpost: {color:'#fff'},
    heartLike: {
        padding: '0px',
        marginTop: '0px',
        marginLeft: '-9px'
    },
    postCommentIcon: {
        position: 'absolute' as any,
        right: theme.spacing(1),
        bottom: theme.spacing(1.5)
    },
    shareButtons: {
        width: '100%',
        display: 'flex' as any,
        justifyContent: 'flex-end'
    },
    actionHandlerSection: {
        padding: '0 16px' 
    },
    commentBox: {
        marginBottom: '10px'
    },
    commentContainer: {
        flexWrap: 'wrap' as any,
        marginTop: '-10px'
    },
    commentDivider: {
        width: '100%',
        color: 'transparent',
        borderTop: '1px solid #ACACAC',
        padding: '0px 16px 0px 9px',
        opacity: '0.5',
        margin: '0 16px 8px 8px'
    }
});

interface Props {
    wall: IWall;
    post: IPost;
    classes: any;
    user: User;
    layout: any;
    comments: any;
    eventName: string | boolean;
    likeDeslikePost: (data: any) => void;
    addComment: (data: any) => void;
    deletePost: (id: string) => void;
    postUpdateFeatured: (data: any) => void;
    loadMoreComments: (data:any) => void;
}

interface State {
    isTruncatedPostExpanded: boolean;
    commentAddActive: boolean;
    commentText: string | null;
    postSettingsOpen: boolean;
    isFeatured: boolean;
    tobeEdited: boolean;
    imageModalOpen: boolean;
    isPostEnligthedfromSocial: string;
}

class PostCard extends Component<Props, State> {
    postCommentElement = createRef<any>();
    state: State = { isTruncatedPostExpanded: false, commentAddActive: false, commentText: null, postSettingsOpen: false, isFeatured: false, tobeEdited: false, imageModalOpen: false, isPostEnligthedfromSocial: '' }
    constructor(props: Props) {
        super(props);
        this.routeLayout = this.routeLayout.bind(this);
        this.titleBodyMedia = this.titleBodyMedia.bind(this);
        this.mediaTitleBody = this.mediaTitleBody.bind(this);
        this.titleMediaBody = this.titleMediaBody.bind(this);
        this.likeHandler = this.likeHandler.bind(this);
        this.handleExpandClick = this.handleExpandClick.bind(this);
        this.postComment = this.postComment.bind(this);
        this.commentTextHandler = this.commentTextHandler.bind(this);
        this.renderHtmlContent = this.renderHtmlContent.bind(this);
        this.deletePost = this.deletePost.bind(this);
        this.imageOpenCloseHandler = this.imageOpenCloseHandler.bind(this);
        this.loadMoreComments = this.loadMoreComments.bind(this);
        this.shareHandler = this.shareHandler.bind(this);
        this.resizeCommentBox = this.resizeCommentBox.bind(this);
        this.cardActionSection = this.cardActionSection.bind(this);        
        this.sharer = this.sharer.bind(this);
        this.brinWindowDownToPost = this.brinWindowDownToPost.bind(this);
        this.updatePsString = this.updatePsString.bind(this);
    }

    componentDidMount() {
        const { wall, post } = this.props;
        const isFeatured = wall.featuredPosts.findIndex((item: any) => item.id === post._id) === -1 ? false : true;
        this.setState({ ...this.state, isFeatured: isFeatured });
        this.postCommentElement.current.addEventListener('input', this.resizeCommentBox);

        /* Check for the social enlighted post */
        const uri = new URL(window.location.href);
        const enlightedPost = uri.searchParams.get('postId') || '';
        this.setState({...this.state, isPostEnligthedfromSocial: enlightedPost });    
        this.brinWindowDownToPost(enlightedPost);   
    }

    public brinWindowDownToPost(postId:any){
        if(!postId) return;
        const elementSelected = document.getElementById('post-' + postId) as HTMLElement;
        const element = document.getElementById('wall-wrapper-21') as HTMLElement;
        setTimeout(() =>  element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'}), 1200);
        setTimeout(() => elementSelected.classList.add('remove-the-shadow'), 10000);
    }

    public handleExpandClick() {
        const { layout } = this.props;
        this.setState({ ...this.state, isTruncatedPostExpanded: !this.state.isTruncatedPostExpanded });
        if (layout === 'function') setTimeout(() => layout(), 700);
    }

    public commentTextHandler(e: any) {
        const { name, value } = e.target;
        this.setState({ ...this.state, [name]: value });
        e.target.style.cssText = `height:${e.target.scrollHeight}px`;
    }

    public resizeCommentBox(e:any){
        e.target.style.height = 'auto';
        e.target.style.height = `${e.target.scrollHeight}px`;
    }

    public postComment() {
        const { addComment, user, post } = this.props;
        const { commentText } = this.state;
        const data = { userId: user.id, postId: post._id, isChildComment: false, comment: commentText };
        if (commentText !== '') addComment(data);
        this.setState({ ...this.state, commentText: null });
    }

    public deletePost() {
        const { deletePost, postUpdateFeatured, wall, post } = this.props;
        const { isFeatured } = this.state;
        const type = isFeatured ? false : true;
        postUpdateFeatured({ wallId: wall._id, postId: post._id, type: type, position: wall?.featuredPosts.length });
        deletePost(post._id || '');
    }

    public renderHtmlContent(data: any) {
        return { __html: data }
    }

    public sharer(type:string, post:any){
        const {wall} = this.props;
        const facebookAPPID = '153696042958202';
        let url = new URL(window.location.href);
        url.searchParams.delete('postId');        
        const paramCheck = url.href.split('?');        
        const origin = (paramCheck.length > 1 && paramCheck[1] !== '') ? url.href.concat('&postId=' + post._id): url.href.concat('?postId=' + post._id);        
        const shareuri = encodeURIComponent(`https://core.pancan.org/share/wall/${post._id}/?wallId=${wall._id}&origin=${origin}&type=${type}`);                    
        (type === 'facebook') ? window.open(`https://www.facebook.com/dialog/share?app_id=${facebookAPPID}&display=popup&href=${shareuri}`, 'facebook-share-dialog', 'width=700,height=600'):
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(wall.twitterTitle || '')} ${encodeURIComponent(wall.twitterDescription)}&url=${shareuri}`, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=700');
    }

    public cardActionSection(){
        const {classes, wall, user, post} = this.props;
        const userLikeIndex = post.likedBy.findIndex((item: any) => item === user.id);
        const like = userLikeIndex !== -1 ? true : false;

        return (
            <CardActions className={classes.heartLike}>
                <IconButton aria-label="Like" onClick={this.likeHandler} className={classes.likeButton}>{like ? <FavoriteIcon /> : <FavoriteBorderIcon />}</IconButton>
                <Typography variant="body2" component="p" className="likes-count">{post.likes}</Typography>
                { wall.socialButtons? 
                    <div className={classes.shareButtons}>
                        {/* Check for facebook elements to be in place */}
                        {wall.facebookTitle && wall.facebookDescription?<IconButton aria-label="share facebook" onClick={() => this.sharer('facebook', post)} className={classes.shareButton} style={{marginRight: '-5px'}}><FacebookIcon /></IconButton>:null}
                        {/* Check for twitter elements to be in place */}
                        {wall.twitterDescription ? <IconButton aria-label="share Twitter" onClick={() => this.sharer('twitter', post)} className={classes.shareButton}><TwitterIcon /></IconButton>:null}
                    </div>
                :null}
            </CardActions>
        );
    }

    public updatePsString(tag:string){
        return tag.replace(/purplestride/g, 'PurpleStride');        
    }
    
    public titleMediaBody() {
        const { post, classes, eventName, wall } = this.props;
        const { isTruncatedPostExpanded } = this.state;
        
        const name = post.userMetadata.user && wall.displayPostUserDetails ? `${post.userMetadata.user.userInfo.firstName || ''} ${post.userMetadata.user.userInfo.lastName || ''}`: false;                
        const featuredTagName = post.featuredTag && post.featuredTag.name !== '' && wall.displayPostFeaturedTags ? post.featuredTag.name: false;
        
        return (
            <div>
                <CardContent className="body-container-title">
                    <Typography variant="h5" component="h2" className="post-title">{post.title}</Typography>                    
                </CardContent>
                <CardContent className={classes.nameHolder + ' body-container-title'}>
                    {(name && name !== ' ')? <p className={classes.name}>{name}</p>:null}
                    {(featuredTagName)? <p className={classes.eventname}>{this.updatePsString(featuredTagName)}</p>:null}
                    {(eventName)? <p className={classes.eventname}>{eventName}</p>:null}                    
                </CardContent>
                {post.postImage ? <CardActionArea onClick={this.imageOpenCloseHandler}><CardMedia className="image-bottom-gutter image-upper-gutter" component="img" alt="post image" image={post.postImage} title="Honor Wall Image" /></CardActionArea> : null}
                <CardContent className={classes.actionHandlerSection}>
                    {this.cardActionSection()}
                </CardContent>
                <CardContent className="body-container-body-text">                    
                    {post.isTruncated ?
                        (<div>
                            {(isTruncatedPostExpanded) ?
                                (<Collapse in={isTruncatedPostExpanded} timeout="auto" unmountOnExit>
                                    <Typography variant="body2" color="textSecondary" component="p" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />
                                </Collapse>)
                                : <Typography className="truncatedText" variant="body2" color="textSecondary" component="p" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />
                            }
                            <CardActions className="truncated-control">
                                <IconButton
                                    className={clsx(classes.expand, { [classes.expandOpen]: isTruncatedPostExpanded })}
                                    onClick={this.handleExpandClick}
                                    aria-expanded={isTruncatedPostExpanded}
                                    aria-label="show more">
                                    <ExpandMoreIcon />
                                </IconButton>
                            </CardActions>
                        </div>)
                        : <Typography variant="body2" color="textSecondary" component="p" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />}
                </CardContent>
            </div>
        );
    }

    public mediaTitleBody() {
        const { post, classes, eventName, wall } = this.props;
        const { isTruncatedPostExpanded } = this.state;
        const name = post.userMetadata.user && wall.displayPostUserDetails ? `${post.userMetadata.user.userInfo.firstName || ''} ${post.userMetadata.user.userInfo.lastName || ''}`: false;                
        const featuredTagName = post.featuredTag && post.featuredTag.name !== '' && wall.displayPostFeaturedTags ? post.featuredTag.name: false;
        return (
            <div>
                {post.postImage ? <CardActionArea onClick={this.imageOpenCloseHandler}><CardMedia component="img" alt="post image" image={post.postImage} title="Honor Wall Image" /></CardActionArea> : null}
                <CardContent className={classes.actionHandlerSection}>
                    {this.cardActionSection()}
                </CardContent>
                <CardContent className="body-container-title">
                    <Typography variant="h5" component="h2" className="post-title">{post.title}</Typography>                    
                </CardContent>      
                <CardContent className={classes.nameHolder + ' body-container-title'}>
                    {(name)? <p className={classes.name}>{name}</p>:null}
                    {(featuredTagName)? <p className={classes.eventname}>{this.updatePsString(featuredTagName)}</p>:null}
                    {(eventName)? <p className={classes.eventname}>{eventName}</p>:null}
                    {this.cardActionSection()}
                </CardContent>          
                <CardContent className="body-container-body-text">
                    {post.isTruncated ?
                        (<div>
                            {(isTruncatedPostExpanded) ?
                                (<Collapse in={isTruncatedPostExpanded} timeout="auto" unmountOnExit>
                                    <Typography variant="body2" color="textSecondary" component="p" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />
                                </Collapse>)
                                : <Typography className="truncatedText" variant="body2" color="textSecondary" component="p" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />
                            }
                            <CardActions className="truncated-control">
                                <IconButton
                                    className={clsx(classes.expand, { [classes.expandOpen]: isTruncatedPostExpanded })}
                                    onClick={this.handleExpandClick}
                                    aria-expanded={isTruncatedPostExpanded}
                                    aria-label="show more">
                                    <ExpandMoreIcon />
                                </IconButton>
                            </CardActions>
                        </div>)
                        : <Typography variant="body2" color="textSecondary" component="p" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />}
                </CardContent>
            </div>
        );
    }

    public titleBodyMedia() {
        const { post, classes, eventName, wall } = this.props;
        const { isTruncatedPostExpanded } = this.state;        
        const name = post.userMetadata.user && wall.displayPostUserDetails ? `${post.userMetadata.user.userInfo.firstName || ''} ${post.userMetadata.user.userInfo.lastName || ''}`: false;                
        const featuredTagName = post.featuredTag && post.featuredTag.name !== '' && wall.displayPostFeaturedTags ? post.featuredTag.name: false;
        return (
            <div>
                <CardContent className="body-container-title">
                    <Typography variant="h5" component="h2" className="post-title">{post.title}</Typography>                    
                </CardContent>
                <CardContent className={classes.nameHolder + ' body-container-title'}>
                    {(name)? <p className={classes.name}>{name}</p>:null}
                    {(featuredTagName)? <p className={classes.eventname}>{this.updatePsString(featuredTagName)}</p>:null}
                    {(eventName)? <p className={classes.eventname}>{eventName}</p>:null}
                    {this.cardActionSection()}
                </CardContent>
                <CardContent className="body-container-body-text">
                    {post.isTruncated ?
                        (<div>
                            {(isTruncatedPostExpanded) ?
                                (<Collapse in={isTruncatedPostExpanded} timeout="auto" unmountOnExit>
                                    <Typography variant="body2" color="textSecondary" component="p" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />
                                </Collapse>)
                                : <Typography className="truncatedText" variant="body2" color="textSecondary" component="p" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />
                            }
                            <CardActions className="truncated-control">
                                <IconButton
                                    className={clsx(classes.expand, { [classes.expandOpen]: isTruncatedPostExpanded })}
                                    onClick={this.handleExpandClick}
                                    aria-expanded={isTruncatedPostExpanded}
                                    aria-label="show more">
                                    <ExpandMoreIcon />
                                </IconButton>
                            </CardActions>
                        </div>)
                        : <Typography variant="body2" color="textSecondary" component="p" dangerouslySetInnerHTML={this.renderHtmlContent(post.description)} />}
                </CardContent>
                <CardContent className={classes.actionHandlerSection}>
                    {this.cardActionSection()}
                </CardContent>
                {post.postImage ? <CardActionArea onClick={this.imageOpenCloseHandler}><CardMedia className="image-bottom-gutter" component="img" alt="post image" image={post.postImage} title="Honor Wall Image" /></CardActionArea> : null}
            </div>
        );
    }

    public routeLayout(): any {
        const { post, layout } = this.props;
        if (typeof layout.updateLayout === 'function') setTimeout(() => layout.updateLayout(), 500);
        switch (post.layout) {
            case 1:
                return this.titleMediaBody();
            case 2:
                return this.mediaTitleBody();
            default:
                return this.titleBodyMedia();
        }
    }

    public likeHandler() {
        const { post, likeDeslikePost, user } = this.props;
        const data = { postId: post._id, type: 'post', userId: user.id, likedBy: post.likedBy };
        likeDeslikePost(data);
    }

    public imageOpenCloseHandler(){
        this.setState({...this.state, imageModalOpen: !this.state.imageModalOpen});
    }

    public loadMoreComments(total:number){
        const {post, loadMoreComments} = this.props;
        const next = Math.round(total / 3) + 1;
        const data = {id: post._id, page:next, perpage: 3}
        loadMoreComments(data);
    }

    public shareHandler(type:string, data:any){
        if(type === 'facebook'){
            return;
        }

    }

    public render() {
        const { classes, post, user, comments, layout} = this.props;
        const { commentText, commentAddActive,  tobeEdited, imageModalOpen, isPostEnligthedfromSocial } = this.state;        
        const canEdit = user.id === post.userId;        
        const postComments = comments.filter((comment:IComment) => comment.postId === post._id);
        
        return (
            <div>
                <ImageModal open={imageModalOpen} action={this.imageOpenCloseHandler} media={post.postImage}/>
                {
                    (tobeEdited) ? (
                        <PostAddEdit layout={layout} action={() => this.setState({ ...this.state, tobeEdited: !this.state.tobeEdited })} tags={post.tags} edit={true} post={post} tagsRef={post.tagsRef} featuredTag={post.featuredTag} />
                        ): (
                        <Card className={isPostEnligthedfromSocial === post._id? classes.enlightedPost: classes.root} id={'post-' + post._id}>
                            {(canEdit) ?
                                (
                                    <SpeedDial
                                        ariaLabel="post settings"
                                        className={classes.speedDial}
                                        icon={<CreateIcon className={classes.editpost}/>}
                                        onClose={() => this.setState({ ...this.state, postSettingsOpen: false })}
                                        onOpen={() => this.setState({ ...this.state, postSettingsOpen: true })}
                                        open={true} // use this if you want to use button to open menu postSettingsOpen
                                        direction={'left'}>
                                        <SpeedDialAction icon={<EditIcon />} tooltipTitle="Edit" onClick={() => this.setState({ ...this.state, tobeEdited: !this.state.tobeEdited })} />
                                        <SpeedDialAction icon={<DeleteIcon />} tooltipTitle="Delete" onClick={this.deletePost} />
                                    </SpeedDial>
                                )
                                : null}
                            {this.routeLayout()}
                            
                            {(postComments.length > 0) ? (
                                <CardContent>
                                    <Typography variant="body2" component="p" className="likes-count">{postComments.length} of {post.totalComments} {postComments.length === 1 ? 'Comment' : 'Comments'}</Typography>
                                    {postComments.map((comment: IComment, key: number) => <Comment key={key} comment={comment} />)}
                                    {postComments.length < post.totalComments? <Button  className="load-comments-btn" onClick={() => this.loadMoreComments(postComments.length)}>Show more</Button>:null}
                                </CardContent>
                            ) : null}
                            <CardActions className={classes.commentContainer}>
                                <span className={classes.commentDivider} />
                                <div className="textarea-comment-wrapper" style={{marginLeft: 2}}>                                
                                    <div className="text-area">
                                        <textarea
                                            className={classes.commentBox}
                                            ref={this.postCommentElement}
                                            onChange={this.commentTextHandler}
                                            name="commentText"
                                            rows={1}
                                            placeholder="Add Comment"
                                            value={commentText || ''}
                                            maxLength={200}
                                            onFocus={() => this.setState({ ...this.state, commentAddActive: true })}
                                            onBlur={(e:any) => {setTimeout(() => this.setState({ ...this.state, commentAddActive: false }), 200); }}></textarea>
                                    </div>
                                    {(commentAddActive) ? (
                                        <Tooltip title={<p style={{fontSize: 14}}>post comment</p>} className={classes.postCommentIcon}>
                                            <Button onClick={this.postComment} color="primary" variant="outlined" size="large"> 
                                                Done
                                            </Button>
                                        </Tooltip>
                                    ) : null}
                                </div>
                            </CardActions>
                        </Card>
                        )
                }
            </div>
        );
    }
}
const mapProps = (app: any) => ({ wall: app.rootReducer.wall, comments: app.rootReducer.comments, user: app.rootReducer.user });
const mapDispatch = (dispatch: Dispatch) => ({
    likeDeslikePost: (data: any) => dispatch({ type: UPDATE_LIKE, payload: data }),
    addComment: (data: any) => dispatch({ type: ADD_COMMENT, payload: data }),
    deletePost: (postId: string) => dispatch({ type: REMOVE_POST, payload: postId }),
    postUpdateFeatured: (data: any) => dispatch({ type: UPDATE_FEATUREDPOST, payload: data }),
    loadMoreComments: (data:any) => dispatch({type:REQUEST_COMMENTS, payload: data})
});
export default connect(mapProps, mapDispatch)(withStyles(styles)(PostCard));